import { ForwardedRef, RefObject, forwardRef, useEffect, useRef, useState } from "react"
import './Footer.css'
import InputBox, { InputType } from "../InputBox/InputBox";
import { Color } from "../../lib/colors";
import { EMAIL_REGEX } from "../../lib/utils";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { Box, List } from "@mui/material";
import { fetchIndustries } from "../../backend/industries";
import { Industry } from "../../../data_types";
import EmailButton from "../socials/EmailButton";
import PhoneButton from "../socials/PhoneButton";
import AddressButton from "../socials/AddressButton";
import BilletMap from "../BilletMap/BilletMap";
import { useMediaQuery, useTheme } from "@mui/material";

const Footer = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {
  const inputBoxRef: RefObject<InputBox> = useRef(null);
  const [data, setData] = useState<{ industries: Industry[] }>({ industries: [] });

  useEffect(() => {
    const loadIndustries = async () => {
      const fetchedData = await fetchIndustries();
      setData(fetchedData);
    };
    loadIndustries();
  }, []);

  const addToMailingList = (email: string) => {
    if (!EMAIL_REGEX.test(email)) {
      inputBoxRef.current!.emphasizeText();
      return;
    }
    inputBoxRef.current!.showText("Added to mailing list.", Color.Green);

    console.log("[Footer.tsx] TODO: add to mailing list.");
  }

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // sm = 600px

  return (
    <Box className="footer">
      <Box className="footer-section" id="footer-logo-container">
        <LazyLoadImage className="footer-logo-item" id="logo" src="/img/icons/logo/logo-light.png" alt="billet-logo" />
        {/* <Box className="footer-logo-item" id="separator"></Box> */}
        <Box className="footer-logo-item" id="address">
          <Box className="footer-address-item" id="address">
            <AddressButton address={["2730 Fenton Rd", "Gloucester, ON K1T 3T7", "Canada"]} addressFontSize={"16px"} addressIconScale={"0.9"} iconTextGap={"5px"}/>
          </Box>
          <Box className="footer-address-item" id="email">
            <EmailButton email={`${process.env.REACT_APP_EMAIL}`} emailFontSize={"16px"} emailIconScale={"0.9"} iconTextGap={"5px"}/>
          </Box>
          <Box className="footer-address-item" id="phone">
            <PhoneButton phone={`${process.env.REACT_APP_PHONE}`} phoneFontSize={"16px"} phoneIconScale={"0.9"} iconTextGap={"5px"}/>
          </Box>
        </Box>
      </Box>
      <Box className="footer-section" id="footer-metadata">
        <Box className="footer-metadata-section" id="email-container">
          <Box id="footer-signup-text">Sign up to receive regular updates about our company.</Box>
          <InputBox id="footer-email" inputType={InputType.INPUT} placeholder="johndoe@email.com" buttonText="Subscribe" onClick={addToMailingList} ref={inputBoxRef} />
        </Box>
        <Box className="footer-metadata-section" id="links-container">
          <BilletMap zoom={isMobile ? 12 : 13}/>
          <Box className="footer-links-container" id="industries">
            <Box className="footer-links-header" id="industries">Industries</Box>
            <List className="industry-link-list">
              {data?.industries?.length > 0 ? (
                data?.industries.map((industry, index) => (
                  <Link key={index} to={`/industries/${industry.displayId}`} className='footer-link-item'>
                    <Box className='footer-link-p'>{industry.industryTitle}</Box>
                  </Link>
                ))
              ) : (
                <Box>No industries available</Box>
              )}
            </List>
          </Box>
          <Box className="footer-links-container" id="company">
            <Box className="footer-links-header" id="company">Company</Box>
            <Link to='/services' className='footer-link-item'>
              <Box className='footer-link-p'>Services</Box>
            </Link>
            <Link to='/news' className='footer-link-item'>
              <Box className='footer-link-p'>News</Box>
            </Link>
            <Link to='/contact' className='footer-link-item'>
              <Box className='footer-link-p'>Contact</Box>
            </Link>
            <Link to='https://www.billetportal.ca' className='footer-link-item'>
              <Box className='footer-link-p'>Login</Box>
            </Link>
          </Box>
        </Box>
        <Box className="footer-section" id="footer-copyright-text">
          <Box className="footer-sub-section" id="terms-and-conditions">
            <a href="/legal/Billet-Precision-Terms-&-Conditions-Rev-C.pdf" target="_blank">Terms & Conditions</a>
          </Box>
          <Box className="footer-sub-section" id="privacy-policy">
            <a href="/legal/Billet-Precision-Privacy-Policy.pdf" target="_blank">Privacy Policy</a>
          </Box>
          <Box className="footer-sub-section" id="copyright">
            © 2024 Billet Precision Ltd.
          </Box>
        </Box>
      </Box>
    </Box>
  );
});


export default Footer;